export default "__VITE_ASSET__b10bd20b__"